import { useEffect, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";

import {
    ListarProdutosPorContaCompleto,
    VerificaProdutoAdimplenteController,
} from "../../../Controllers/Cobranca/ContaProduto/ContaProdutoController";

import moment from "moment";
import "moment/locale/pt-br";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ModalComponent from "../../Modais";
import { IComponentModal } from "../../Modais/IModalComponent";
import { useAtendimentoPage } from "../../../Context/AtendimentoPage";
import { formatMoneyReais } from "../../../Tools/FormatTools";

import "./styles.css";
import InformacoesVenda from "./InformacoesVenda";
import CopyToClipboard from "../../Utils/CopyToClipboard";
import { useUserInfor } from "../../../Context/User";
import OrSpinner from "../../Utils/OrSpinner";
import { ACESSOS } from "../../../Routes/Acessos";
import useAsyncEffect from "../../../hooks/useAsyncEffect";

moment.locale("pt-br");

interface IProdutosCobrancaProps {
    idConta: number;
    idProdutoAtendimento: number;
}
export default function ProdutosCobranca(props: IProdutosCobrancaProps) {
    const { idModulo } = useAtendimentoPage();

    const { ID_ORGANIZACAO } = useUserInfor().OrgInfor;
    const { OrgInfor } = useUserInfor();

    const emccampMode = "E830AEF3-49DF-4DC1-8560-DC78EE448F01";

    const { setQtdOutrosProdutosInadimplentes } = useAtendimentoPage();
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const [statuses, setStatuses] = useState<(boolean | null)[]>([]);
    const [verificandoAdimplencia, setVerificandoAdimplencia] = useState(true);

    const {
        value: lstProdutosPorContaCompleto,
        loading: lstProdutosPorContaCompletoLoading,
    } = useAsyncEffect(() =>
        ListarProdutosPorContaCompleto(props.idConta, idModulo)
    );

    useEffect(() => {
        const fetchData = async () => {
            try {
                const statusesArray = await Promise.all(
                    lstProdutosPorContaCompleto?.map(async (produto) => {
                        try {
                            if (produto.UNIDADE.ID_CHAVE_ERP_VENDA) {
                                const res =
                                    await VerificaProdutoAdimplenteController(
                                        produto.UNIDADE.ID_CHAVE_ERP_VENDA
                                    );
                                return res;
                            } else {
                                return null;
                            }
                        } catch (error) {
                            return null;
                        }
                    }) || []
                );

                setStatuses(statusesArray);
            } finally {
                setVerificandoAdimplencia(false);
                if (setQtdOutrosProdutosInadimplentes)
                    setQtdOutrosProdutosInadimplentes(
                        lstProdutosPorContaCompleto?.filter(
                            (p) =>
                                p.UNIDADE.ID_UNIDADE !==
                                    props.idProdutoAtendimento &&
                                p.UNIDADE.FL_DIVIDA
                        ).length ?? 0
                    );
            }
        };

        fetchData();
    }, [
        lstProdutosPorContaCompleto,
        props.idProdutoAtendimento,
        setQtdOutrosProdutosInadimplentes,
    ]);

    function transformTextInJson(idTitutuloSienge: string) {
        const EmpresaCod = idTitutuloSienge.slice(0, 3);
        const FilialCod = idTitutuloSienge.slice(3, 5);
        const EImoNumero = idTitutuloSienge.slice(5, 9);
        const ContratoNumero = idTitutuloSienge.slice(9, 13);
        const ContratoSeq = idTitutuloSienge.slice(13, 14);

        const obj = {
            EmpresaCod,
            FilialCod,
            EImoNumero,
            ContratoNumero,
            ContratoSeq,
        };
        return JSON.stringify(obj);
    }

    return (
        <OrSpinner loading={lstProdutosPorContaCompletoLoading} spinner="capys">
            {lstProdutosPorContaCompleto?.length ? (
                <>
                    <div className="card card-custom w-auto gutter-b">
                        <div className="d-flex flex-wrap align-items-center justify-content-start p-8 produtosCard y-scroll">
                            {lstProdutosPorContaCompleto?.map(
                                (produto, index) => {
                                    const isProdutoAtendido =
                                        produto.UNIDADE.ID_UNIDADE ===
                                        props.idProdutoAtendimento;

                                    const adimplenciaValue = statuses[index];

                                    const semChaveErp =
                                        produto.UNIDADE.ID_CHAVE_ERP_VENDA ===
                                            null ||
                                        produto.UNIDADE.ID_CHAVE_ERP_VENDA ===
                                            "";

                                    const getStatusClass = () => {
                                        if (semChaveErp) {
                                            return "symbol-light-dark";
                                        } else if (
                                            verificandoAdimplencia ||
                                            adimplenciaValue === null
                                        ) {
                                            return "symbol-light-warning";
                                        } else {
                                            return adimplenciaValue
                                                ? "symbol-light-danger"
                                                : "symbol-light-success";
                                        }
                                    };

                                    return (
                                        <div
                                            key={produto.UNIDADE.ID_UNIDADE}
                                            className={`d-flex flex-wrap align-items-center justify-content-end p-1 m-2 unidadeCard  ${
                                                isProdutoAtendido &&
                                                "ribbon ribbon-clip ribbon-left"
                                            }`}
                                            style={{ maxWidth: "355px" }}
                                        >
                                            {isProdutoAtendido && (
                                                <OverlayTrigger
                                                    overlay={
                                                        <Tooltip id="tooltip-disabled">
                                                            Produto em
                                                            Atendimento
                                                        </Tooltip>
                                                    }
                                                >
                                                    <div
                                                        className="ribbon-target"
                                                        style={{ top: "2px" }}
                                                    >
                                                        <span className="ribbon-inner bg-warning"></span>
                                                        <i className="fa fa-star text-white"></i>
                                                    </div>
                                                </OverlayTrigger>
                                            )}

                                            <div className="d-flex align-items-center px-6 pt-2">
                                                <div className="d-flex flex-column">
                                                    <span className="text-right text-dark font-weight-bold text-hover-primary font-size-h5 mb-0">
                                                        {
                                                            produto.UNIDADE
                                                                .DS_UNIDADE
                                                        }
                                                    </span>
                                                    <span className="text-right text-muted font-weight-bold">
                                                        {
                                                            produto.DS_EMPREENDIMENTO
                                                        }
                                                    </span>
                                                </div>

                                                <div className="flex-shrink-0 ml-2 mt-lg-0 mt-3">
                                                    <OverlayTrigger
                                                        overlay={
                                                            <Tooltip id="tooltip-disabled">
                                                                {emccampMode ===
                                                                    ID_ORGANIZACAO &&
                                                                idModulo ===
                                                                    ACESSOS
                                                                        .ASSISTENCIA
                                                                        .ID_MODULO
                                                                    ? null
                                                                    : semChaveErp
                                                                    ? "Sem chave ERP cadastrada"
                                                                    : verificandoAdimplencia ||
                                                                      adimplenciaValue ===
                                                                          null
                                                                    ? "Carregando..."
                                                                    : adimplenciaValue
                                                                    ? "Venda Inadimplente"
                                                                    : "Venda Adimplente"}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <div
                                                            className={`symbol symbol-md-50 ${
                                                                emccampMode ===
                                                                    ID_ORGANIZACAO &&
                                                                idModulo ===
                                                                    ACESSOS
                                                                        .ASSISTENCIA
                                                                        .ID_MODULO
                                                                    ? "symbol-light-success"
                                                                    : getStatusClass()
                                                            }`}
                                                        >
                                                            <span className="symbol-label font-size-h3 font-weight-boldest">
                                                                <FontAwesomeIcon
                                                                    icon={
                                                                        faHome
                                                                    }
                                                                />
                                                            </span>
                                                        </div>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>

                                            <div className="card-body pt-4 d-flex flex-column justify-content-between ribbon ribbon-top ribbon-ver">
                                                {emccampMode ===
                                                    ID_ORGANIZACAO &&
                                                idModulo ===
                                                    ACESSOS.ASSISTENCIA
                                                        .ID_MODULO ? null : (
                                                    <>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <span className="text-dark-75 font-weight-bolder mr-2">
                                                                Valor
                                                            </span>
                                                            <span className="text-muted font-weight-bold">
                                                                {formatMoneyReais(
                                                                    produto
                                                                        .UNIDADE
                                                                        .VL_PRODUTO ||
                                                                        0
                                                                )}
                                                            </span>
                                                        </div>
                                                        <div className="d-flex justify-content-between align-items-center ">
                                                            <span className="text-dark-75 font-weight-bolder mr-2">
                                                                N° Parcelas
                                                                Abertas
                                                            </span>
                                                            <span className="text-muted font-weight-bold">
                                                                {
                                                                    produto
                                                                        .UNIDADE
                                                                        .NR_PARCELAS_ABERTAS
                                                                }
                                                            </span>
                                                        </div>
                                                        <div className="d-flex justify-content-between align-items-center ">
                                                            <span className="text-dark-75 font-weight-bolder mr-2">
                                                                Vl. Parcelas
                                                                Abertas
                                                            </span>
                                                            <span className="text-muted font-weight-bold">
                                                                {
                                                                    produto
                                                                        .UNIDADE
                                                                        .VL_PARCELAS_EM_ABERTO
                                                                }
                                                            </span>
                                                        </div>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <span className="text-dark-75 font-weight-bolder mr-2">
                                                                Data da Venda
                                                            </span>
                                                            <span className="text-muted font-weight-bold">
                                                                {moment(
                                                                    produto
                                                                        .UNIDADE
                                                                        .DT_VENDA
                                                                ).format("LL")}
                                                            </span>
                                                        </div>
                                                    </>
                                                )}

                                                <div className="d-flex justify-content-between align-items-center my-1">
                                                    <span className="text-dark-75 font-weight-bolder mr-2">
                                                        ID CHAVE ERP
                                                    </span>
                                                    <span className="text-muted font-weight-bold">
                                                        {
                                                            produto.UNIDADE
                                                                .ID_CHAVE_ERP_VENDA
                                                        }
                                                    </span>
                                                </div>

                                                {produto.DS_STATUS_ESCRITURA && (
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <span className="text-dark-75 font-weight-bolder mr-2">
                                                            Status Escritura
                                                        </span>
                                                        <OverlayTrigger
                                                            overlay={
                                                                <Tooltip id="tooltip-disabled">
                                                                    {produto.DS_STATUS_ESCRITURA.split(
                                                                        ","
                                                                    ).join(
                                                                        " - "
                                                                    )}
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <div className="d-flex justify-content-end">
                                                                <span className="text-muted font-weight-bold pr-1 m-0">
                                                                    {produto.DS_STATUS_ESCRITURA.split(
                                                                        ","
                                                                    ).length > 0
                                                                        ? produto.DS_STATUS_ESCRITURA.split(
                                                                              ","
                                                                          )[0]
                                                                        : ""}
                                                                </span>
                                                                <CopyToClipboard>
                                                                    {produto.DS_STATUS_ESCRITURA.split(
                                                                        ","
                                                                    ).join(
                                                                        " - "
                                                                    )}
                                                                </CopyToClipboard>
                                                            </div>
                                                        </OverlayTrigger>
                                                    </div>
                                                )}

                                                {produto.UNIDADE
                                                    .ID_CHAVE_SIENGE && (
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <span className="text-dark-75 font-weight-bolder mr-2">
                                                            ID TÍTULO
                                                        </span>
                                                        <span className="text-muted font-weight-bold">
                                                            {
                                                                produto.UNIDADE
                                                                    .ID_CHAVE_SIENGE
                                                            }
                                                            <CopyToClipboard className="ml-2">
                                                                {transformTextInJson(
                                                                    produto
                                                                        .UNIDADE
                                                                        .ID_CHAVE_SIENGE
                                                                )}
                                                            </CopyToClipboard>
                                                        </span>
                                                    </div>
                                                )}
                                                {OrgInfor.COD_ERP_INTEGRACAO ===
                                                    "UAU" && (
                                                    <div
                                                        role="button"
                                                        className="text-primary text-hover-info w-100 text-right"
                                                        onClick={() => {
                                                            if (
                                                                produto.UNIDADE
                                                                    .ID_CHAVE_ERP_VENDA
                                                            ) {
                                                                setModal({
                                                                    size: "xl",
                                                                    noHeader:
                                                                        true,
                                                                    noFooter:
                                                                        true,
                                                                    scrollable:
                                                                        true,
                                                                    Children: (
                                                                        <InformacoesVenda
                                                                            ID_CHAVE_ERP_VENDA={
                                                                                produto
                                                                                    .UNIDADE
                                                                                    .ID_CHAVE_ERP_VENDA
                                                                            }
                                                                            idContaProduto={
                                                                                produto
                                                                                    .UNIDADE
                                                                                    .ID_CONTA_PRODUTO
                                                                            }
                                                                            showParcelas={
                                                                                !isProdutoAtendido &&
                                                                                produto
                                                                                    .UNIDADE
                                                                                    .FL_DIVIDA
                                                                            }
                                                                            DS_EMPREENDIMENTO={
                                                                                produto.DS_EMPREENDIMENTO
                                                                            }
                                                                            DS_UNIDADE={
                                                                                produto
                                                                                    .UNIDADE
                                                                                    .DS_UNIDADE
                                                                            }
                                                                        />
                                                                    ),
                                                                });
                                                                setShow(true);
                                                            }
                                                        }}
                                                    >
                                                        Informações da Venda
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                }
                            )}
                        </div>
                    </div>
                    <ModalComponent
                        setShow={setShow}
                        show={show}
                        ModalComponent={modal}
                    />
                </>
            ) : (
                <div className="text muted text-center">
                    Esse cliente não possui produtos
                </div>
            )}
        </OrSpinner>
    );
}
